export default class Constants {
  /* Settings */
  static CAT_MENU_SLIDER_SETTINGS = {
    dots: false,
    infinite: false,
    speed: 100,
    slidesToShow: 1,
    slidesToScroll: 2,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          arrows: false,
        },
      },
    ]
  };

  static PRODUCT_SLIDER_SETTINGS = {
    dots: false,
    infinite: false,
    speed: 100,
    slidesToShow: 1,
    slidesToScroll: window.innerWidth <= 770 ? 1 : 4,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          arrows: false,
        },
      },
    ]
  };

  static STORE_BANNER_SLIDER_SETTINGS = {
    dots: false,
    infinite: false,
    speed: 100,
    slidesToShow: 4,
    slidesToScroll: 2,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          arrows: false,
        },
      },
    ]
  }

  static DISPLAY_BANNER_SLIDER_SETTINGS = {
    dots: false,
    infinite: false,
    speed: 100,
    slidesToShow: 3,
    slidesToScroll: 2,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          arrows: false,
        },
      },
    ]
  }

  /* Product list tab types */
  static OPPORTUNITY = "Opportunity";
  static PROMOTION = "Promotion";
  static SCHEME = "Scheme";
  static RELEVANT = "Relevant";
  static ALL = "ALL";
  static SMART_BASKET = "SmartBasket";
  static MUST_TRY = "Must Try";

  /* Focused tab notation */
  static PROMOTION_TAB_NOTATION = "P";
  static OPPORTUNITY_TAB_NOTATION = "O";
  static RELEVANT_TAB_NOTATION = "R";

  /* Landing screen notation */
  static PRODUCT_LIST_SCREEN_NOTATION = "Order";

  /* Query string types */
  static LANDING_SCREEN = "LS";
  static FOCUSED_TAB = "FT"

  /* Filter */
  static filterOrder = ["BR", "CAT", "SUCAT"];

  /* Local Storage */
  static LcKey = "state";
  static PAYMENT_REQUESTED = "paymentRequested";

  /* Scheme Logic */
  static AND = "AND";
  static ANY = "ANY";
  static ONLY = "ONLY";
  static OR = "OR"

  /* Page Types */
  static SCHEME_DETAILS = "SchemeDetails";
  static BANNER_DETAILS = "BannerDetails";
  static SCHEME_LIST = "SchemeList";
  static OFFER_ZONE = "OfferZone";
  static PRODUCT_TABS = "ProductTabs";
  static FAV_PRODUCTS = "FavProducts";
  static VIEW_ALL_PRODUCTS = "ViewAllProducts";
  static VIEW_SMART_LIST_PRODUCTS = "ViewSmartListProducts";
  static CASE_QTY = "CaseQty";
  static PIECE_QTY = "PieceQty";
  static PRODUCT_DETAILS = "ProductDetails";
  static ORDER_HISTORY = "OrderHistory";
  static ORDER_HISTORY_DETAILS = "OrderHistoryDetails";
  static CANCEL_ORDER = "CancelOrder";
  static SALES_RETURN_HISTORY = "SalesReturnHistory";
  static ORDER_STATUS_DELIVERY = "OrderStatusDelivery";
  static SMART_LIST_PRODUCTS = "SmartListProducts";
  static SALES_RETURN_PRODUCT_LIST = "SalesReturnProductList";
  static EXCHANGE_RETURN_PRODUCT_LIST = "ExchangeReturnProductList";
  static EXCHANGE_ORDER_PRODUCT_LIST = "ExchangeOrderProductList";
  static PLACE_ORDER_PRODUCT_LIST = "PlaceOrderProductList";
  static SALES_RETURN_SUMMARY = "SalesReturnSummary";
  static ORDER_SUMMARY = "OrderSummary";
  static ORDER_SUMMARY_ITEM ="OrderSummaryItem";
  static CHECK_OUT = "CheckOut";

  /* Return reason modules */
  static SALES_RETURN_REASON = "salesReturnReason";
  static EXCHANGE_RETURN_REASON = "exchangeReturnReason";

  /* growth factor type  */
  static GROWTH_FACTOR_QUANTITY = "value";
  static GROWTH_FACTOR_QUANTITY_PERCENTAGE = "percentage";

  /* Customer Id */
  static P_AND_G = "png";
  static JNJ = "jnj";
  static KELLOGGS = "kelloggs";

  /* Reducers Names */
  static REDUCER_HOT_DEALS = "hotDeals";
  static REDUCER_PAST_PURCHASE = "pastPurchase";
  static REDUCER_RECOMMENDED = "recommended";
  static REDUCER_SIMILAR_PRODUCTS = "similarProducts";
  static REDUCER_PRODUCTS = "products";
  static REDUCER_CART = "cart";
  static REDUCER_SMART_LIST_PRODUCTS = "smartListProducts";
  static REDUCER_PRODUCT_DETAILS = "productDetails";
  static REDUCER_SUGGESTED_PRODUCTS = "suggestedProducts";
  static REDUCER_REPEAT_MY_LAST_ORDER_PRODUCTS = "repeatMyLastOrder";

  /* smartList Details Type */
  static REDUCER_SMART_LIST = "smartListProducts";

  /* View All Page Types */
  static PAGE_TYPE_RECOMMENDED = "recommended";
  static PAGE_TYPE_HOT_DEALS = "hotDeals";
  static PAGE_TYPE_BEST_SELLING_PRODUCTS = "bestSellingProducts";
  static PAGE_TYPE_SIMILAR_PRODUCTS = "similarProducts";
  static PAGE_TYPE_REPEAT_ORDER = "repeatOrder";
  static PAGE_TYPE_EDIT_ORDER="editOrder";

  /* Sorting Filter Types */
  static PRICE_ASC = "Price_ASC";
  static PRICE_DESC = "Price_DESC";
  static NAME_ASC = "Name_ASC";
  static NAME_DESC = "Name_DESC";
  static DATE_ASC = "Date_ASC";
  static DATE_DESC = "Date_DESC";
  static POINT_ASC = "Point_ASC";
  static POINT_DESC = "Point_DESC";
  static DEFAULT = "Default";

  /* History filter types */
  static DATE_RANGE = "DateRange";
  static MONTH = "Month";

  /* Invoice Status */
  static INVOICE_DELIVERED = "Delivered";

  /* Order price details page types */
  static PRICE_DETAILS_CHECKOUT = "checkout";
  static PRICE_DETAILS_ORDER_HISTORY = "orderHistory";

  /* Path Include */
  static PATH_INCLUDE_SALES_RETURN_PRODUCTS = "/ivy/salesReturnProducts/";
  static PATH_INCLUDE_PRODUCTS = "/ivy/products/";
  static PATH_INCLUDE_PRODUCT = "/ivy/product/";

  /* Date time format */
  static DD_MM_YYYY = "DD-MM-YYYY";
  static YYYY_MM_DD = "YYYY-MM-DD";
  static MM_YYYY = "MM-YYYY";
  static YYYY_MM = "YYYY-MM";
  static DD = "DD";
  static MMMM_YYYY = "MMMM-YYYY";

  /* Toast Message Types */
  static SUCCESS = "Success";
  static ERROR = "Error";
  static INFO = "Info";
  static WARNING = "Warning";

  /* Product related info */
  static QTY = "QTY";
  static SV = "SV";
  static PER = "PER";
  static WEIGHT = "WEIGHT"

  /* Order resource */
  static SFA = "SFA";
  static RA = "RA";

  /* Payment tab type */
  static UNPAID_INVOICE = "UnpaidInvoice";
  static PAID_INVOICE = "PaidInvoice";

  /* Payment result page type */
  static PAYMENT_SUCCESS = "success";
  static PAYMENT_FAILURE = "failure";

  /* Payment Status */
  static PARTIALLY_PAID = "Partially Paid";
  static PAID = "Paid";

  /* AttrFilter element type */
  static MULTIPLE = "Multiple";
  static SINGLE = "Single";
  static RANGE = "Range";

  /* Attr filter view type */
  static ATTR_MOBILE = "AttrMobile";
  static ATTR_WEB = "AttrWeb";

  /* Address Page Type */
  static ADD_ADDR = "AddAddress";
  static EDIT_ADDR = "EditAddress";

  /* Consumer Status */
  static BToC_CONSUMERS_STATUS_APPROVED = 'A';
  static BToC_CONSUMERS_STATUS_PENDING = 'P';

  /* Consumer Status Action */
  static BToC_CONSUMERS_STATUS_ACTION_APPROVE = 'A';
  static BToC_CONSUMERS_STATUS_ACTION_REJECT = 'R';

  /* Product Status Action */
  static BToC_PRODUCT_ACTION_CREATE = 'C';
  static BToC_PRODUCT_ACTION_UPDATE = 'U';
  static BToC_PRODUCT_ACTION_DELETE = 'D';

  /* Display Content Variants */
  static BToC_CONTENT_VARIANT_DISPLAY = 'display';
  static BToC_CONTENT_VARIANT_ASSET = 'asset';

  static BToC_STORE_DASHBOARD_NAVIGATION_CONSUMERS = 'consumers';
  static BToC_STORE_DASHBOARD_NAVIGATION_PRODUCTS = 'storeProducts';
  static BToC_STORE_DASHBOARD_NAVIGATION_DISPLAY = 'storeDisplay';

  static BToC_STORE_DASHBOARD_CARD_SIZE_DEFAULT = 'Default';
  static BToC_STORE_DASHBOARD_CARD_SIZE_MEDIUM = 'Medium';
  static BToC_STORE_DASHBOARD_CARD_SIZE_LARGE = 'Large';

  /* Attr filter page type */
  static PLACE_ORDER_ATTR = "PlaceOrderAttr";
  static SALES_RETURN_ATTR = "SalesReturnAttr";
  static EXCHANGE_ORDER_ATTR = "ExchangeOrderAttr";

  /* Complaint module meta data */
  static COMPLAINT_TYPE = "COMPL_TYPE"
  static COMPLAINT_REASON = "COMPL_REASON"
  static COMPLAINT_DISPOSAL_METHOD = "COMPL_DISP_MET"
  static COMPLAINT_RETURN_TO = "COMPL_RET_TO"

  /* Complaint module fields max length */
  static COMPLAINT_MAX_LENGTH = {
    InvoiceNo: 50,
    Remarks: 255,
    ConsumerName: 100
  }

  /* Amazon S3 BLOB directory */
  static ROOT_DIR_ASSET = "RootDirAsset";
  static ROOT_DIR_COMPLAINT = "RootDirComplaint";
  static ROOT_DIR_BANNER = "RootDirBanner";
  static ROOT_DIR_PRODUCT = "RootDirProduct";

  /* Character length options for input Fields */
  static BToC_INPUT_MAX_LENGTH = {
    consumer: {
      name: 100,
      phone: 10,
      address: 255,
    },
    product: {
      categoryCode: 25,
      categoryName: 100,
      brandCode: 25,
      brandName: 100,
      skuCode: 25,
      skuName: 100,
      mrpPrice: 6,
      sellPrice: 6,
    },
    display: {
      name: 100,
      value: 100,
      serial: 100,
      vendor: 100,
      type: 100,
    }
  }

  /* Category And SubCat */
  static CAT = "cat";
  static SUB_CAT = "subCat"

  /* Order summary QTY filter level code */
  static BRAND = "BR";

  /* Selected Redeem Options */
  static CASH = "CASH";
  static PRODUCT = 'PRODUCT';

  /* Currency symbols */
  static CURRENCY_INR = "₹";

  /* Static content template */
  static APP_CONTENT_TEMPLATE = "APP_CONTENT_TEMPLATE";

  /* Account Ledger */
  static DOWNLOAD_FILE_NAME = "AccountLedger";

  /* My Orders Excel Export */
  static MY_ORDERS_EXPORT = "MyOrdersExport";
  static MY_ORDER_DETAILS_EXPORT = "MyOrderDetails"

  /* Error Code */
  static DMS_SESSION_EXPIRED = "E22";
  static RA_SESSION_EXPIRED = "EXP";

  /* RA Error Code */
  static RA_NO_DATA = "E012";
  static RA_PENDING_ORDER_ERROR_CODE = "E040";
  static ORDER_UPLOAD_FAILURE = "E039";
  static E044 = "E044";
  static INVALID_VERSION = "E_INVALID_VERSION";

  /* UOM  */
  static CASE = "case";
  static PIECE = "piece"

  /* Delivery address section actions */
  static ADDRESS_ACTION_ADD = "add";
  static ADDRESS_ACTION_EDIT = "edit";
  static ADDRESS_ACTION_DELETE = "delete";
  static ADDRESS_ACTION_CHANGE = "change";

  /* product Card Labels */
  static MRP_LABEL = "MRP";
  static SP_LABEL = "SP";
  static CONVERSION_QTY_LABEL = "ConversionQty";

  /*  cart page labels */
  static TAX_LABEL = "Tax";
  static DISCOUNT_LABEL = "Discount";
  static NET_LABEL = "Net";
  static DISCLAIMER_LABEL = "Disclaimer";
  static ORDER_VOLUME_LABEL = "OrderVolume";

  /* Show profile sections */
  static PROFILE_SECTION_CREDIT_DETAILS = "creditDetails";
  static PROFILE_SECTION_MY_COMPANY_REP_DETAILS = "myCompanyRepDetails";
  static PROFILE_SECTION_MY_DIST_REP_DETAILS = "myDistRepDetails";

  /* Show customer care sections */
  static SUPPORT_HELPLINE_MOBILE = "Mobile";
  static SUPPORT_HELPLINE_EMAIL = "Email";
  static SUPPORT_HELPLINE_EXTERNAL_LINK = "ExternalLink";

  /* Hide profile fields */
  static PROFILE_FIELD_FIRST_NAME = "FirstName";
  static PROFILE_FIELD_MIDDLE_NAME = "MiddleName";
  static PROFILE_FIELD_LAST_NAME = "LastName";
  static PROFILE_FIELD_EMAIL = "Email";
  static PROFILE_FIELD_MOBILE = "Mobile";
  static PROFILE_FIELD_CHANNEL = "Channel";
  static PROFILE_FIELD_SUB_CHANNEL = "SubChannel";
  static PROFILE_FIELD_PAN = "PAN";
  static PROFILE_FIELD_GST = "GST";
  static PROFILE_FIELD_DSchedule = "DeliverySchedule"

  /* Order status code */
  static CANCEL_ORDER_STATUS = "C";
  static OPEN_ORDER_STATUS = "I";
  static ACKNOWLEDGED_ORDER_STATUS = "B";
  static NON_INVOICED_ORDER_STATUS = "N";
  static ALLOCATED_ORDER_STATUS = "A";
  static INVOICED_ORDER_STATUS = "S";
  static PARTIALLY_COMPLETED_ORDER_STATUS = "P";
  static HOLD_ORDER_STATUS = "H";
  static REJECTED_ORDER_STATUS = "R";
  static NOT_DELIVERED_ORDER_STATUS = "X";

  /* Sales Return status code */
  static SALES_RETURN_STATUS_SUBMITTED = "S";
  static SALES_RETURN_STATUS_APPROVED = "A";
  static SALES_RETURN_STATUS_REJECTED = "C";
  static SALES_RETURN_STATUS_PENDING = "P";
  static SALES_RETURN_STATUS_OPEN = "I";

  /* Rewards status code */
  static REWARDS_HISTORY_STATUS_PENDING = "P";
  static REWARDS_HISTORY_STATUS_APPROVED = "S";
  static REWARDS_HISTORY_STATUS_REJECTED = "R";
  static REWARDS_HISTORY_STATUS_DELIVERED = "D";
  static REWARDS_HISTORY_STATUS_COMPLETED = "C";

  /* Home page sections */
  static HOME_PAGE_SECTIONS_BANNER = "SchemeBanner";
  static HOME_PAGE_SECTIONS_CATEGORY = "Category"
  static HOME_PAGE_SECTIONS_ONE_CLICK = "ShopByOneClick"
  static HOME_PAGE_SECTIONS_OFFER_ZONE = "OfferZone"
  static HOME_PAGE_SECTIONS_RECOMMENDED = "Recommended"
  static HOME_PAGE_SECTIONS_BESTSELLING = "BestSelling"

  /* GA Hooks sections actions  */
  static GA_EVENTS_PURCHASE = "purchase";
  static GA_EVENTS_VIEW_PROMOTION_DETAILS = "view_promotion_details";
  static GA_EVENTS_ADD_TO_WISHLIST = "add_to_wishlist";
  static GA_EVENTS_ADD_TO_CART = "add_to_cart";
  static GA_EVENTS_SEARCH = "search";
  static GA_EVENTS_PAGE_VIEW = "page_view";
  static GA_EVENTS_TAB_CHANGE = "tab_change";
  static GA_EVENTS_REMOVE_FROM_CART = "remove_from_cart";
  static GA_EVENTS_CHECKOUT = "checkout";
  static GA_EVENTS_PUSH_NOTIFICATION = "push_notification";
  static GA_EVENTS_LOGIN = "login";
  static GA_EVENTS_LOGOUT = "logout";
  static GA_EVENTS_PRODUCT_COMPLAINT = "product_complaint";
  static GA_EVENTS_BEGIN_CHECKOUT = "begin_checkout";
  static GA_EVENTS_VIEW_CART = "view_cart";
  static GA_EVENTS_VIEW_ITEM = "view_item";
  static GA_EVENTS_VOICE_SEARCH_INITIATION = "voice_search_initiation";
  static GA_EVENTS_BARCODE_SEARCH_INITIATION = "barcode_search_initiation";
  static GA_EVENTS_SCROLL_SHOW_MORE_BUTTON = "show_more_button";
  static GA_EVENTS_PRODUCT_HISTORY_SEARCH = "product_history_search";
  static GA_EVENTS_SMART_LIST_DELETE = "smart_list_delete";
  static GA_EVENTS_ADD_TO_SMART_LIST = "add_to_smart_list";
  static GA_EVENTS_CANCEL_ORDER = "cancel_order";
  static GA_EVENTS_MENU_DRAWER = "menu_drawer";
  static GA_EVENTS_FILTER_APPLY = "filter_apply";
  static GA_EVENTS_REMOVE_FROM_WISHLIST = "remove_from_wishlist";
  static GA_EVENTS_REMOVE_FROM_SALES_RETURN_SUMMARY = "remove_from_sales_return_summary";
  static GA_EVENTS_SUBMIT_SALES_RETURN_SUMMARY = "submit_sales_return_summary";
  static GA_EVENTS_NOTIFICATION_READ = "notification_read";
  static GA_EVENTS_SUPPORT_HELPLINE = "support_helpline";
  static GA_EVENTS_SHOW_ORDER_SUMMARY = "show_order_summary";
  static GA_EVENTS_DELIVERY_ADDRESS_CHANGE = "delivery_address_change";
  static GA_MY_REWARDS_FILTER = "my_rewards_filter";
  static GA_MY_REWARDS_REDEEM = "my_rewards_redeem";
  static GA_CHANGE_MOBILE_NUMBER = "change_mobile_number";
  static GA_ERROR_EVENT = "exception_event";
  static GA_WARING_EVENT = "warning_event";

  /* Support Helpline types */
  static SUPPORT_HELPLINE_TYPE_MOBILE = "Mobile";
  static SUPPORT_HELPLINE_TYPE_EMAIL = "Email"

  /* Push notification types */
  static PUSH_NOTIFICATION_TYPE_FOREGROUND_MSG_DELIVERY = "Foreground Message Delivery";

  /* Banner Types */
  static BANNER_TYPE_RTR = "RTR";
  static BANNER_TYPE_CH = "CH";
  static BANNER_TYPE_LOC = "LOC";
  static BANNER_TYPE_DIST = "DIST";
  static BANNER_TYPE_SCH = "SCH";
  static BANNER_TYPE_SKU = "SKU";
  static BANNER_TYPE_DL = "DL";

  /* Media Types */
  static MEDIA_TYPE_PNG = ".png";
  static MEDIA_TYPE_JPG = ".jpg";
  static MEDIA_TYPE_JPEG = ".jpeg";
  static MEDIA_TYPE_TIFF = ".tiff";
  static MEDIA_TYPE_MP4 = ".mp4";
  static MEDIA_TYPE_MOV = ".mov";
  static MEDIA_TYPE_PDF = ".pdf";
  static MEDIA_TYPE_PPT = ".ppt";
  static MEDIA_TYPE_PPTX = ".pptx";
  static MEDIA_TYPE_DOCX = ".docx";
  static MEDIA_TYPE_DOC = ".doc";
  static MEDIA_TYPE_XLS = ".xls";
  static MEDIA_TYPE_XLSX = ".xlsx";
  static MEDIA_TYPE_ODS = ".ods";
  static MEDIA_TYPE_CSV = ".csv";
  static MEDIA_TYPE_TXT = ".txt";
  static MEDIA_TYPE_GIF = ".gif";

  /* Reward Page Types */
  static REWARD_PRODUCT_LIST = "rewardProductList";
  static REWARD_PRODUCT_SUMMARY = "rewardProductSummary";
  static REWARD_PRODUCT_HISTORY = "rewardProductHistory";

  /* Component Types */
  static COMPONENT_TYPE_DD_MULTI_SELECT = "DD_MULTISELECT";
  static COMPONENT_TYPE_DD_SINGLE_SELECT = "DD_SINGLESELECT";
  static COMPONENT_TYPE_EMAIL = "EMAIL";
  static COMPONENT_TYPE_NUM = "NUM";
  static COMPONENT_TYPE_FREE_TEXT = "FREE_TEXT";
  static COMPONENT_TYPE_MULTISELECT = "MULTISELECT";
  static COMPONENT_TYPE_OPT = "OPT";
  static COMPONENT_TYPE_PERC = "PERC";
  static COMPONENT_TYPE_PH_NO = "PH_NO";
  static COMPONENT_TYPE_POLL = "POLL";
  static COMPONENT_TYPE_TEXT = "TEXT";

  /* Upload Type */
  static UPLOAD_TYPE_CAMERA = "camera";
  static UPLOAD_TYPE_UPLOAD = "upload";
  static UPLOAD_TYPE_BOTH = "both";

  /* Monthly Sales SKU Details Config */
  static MONTHLY_SALES_SALES_VALUE = "SV";
  static MONTHLY_SALES_PURCHASE_VALUE = "PV";
  static MONTHLY_SALES_RANGE_MULTIPLIER = "RM";
  static MONTHLY_SALES_FREQUENCY_MULTIPLIER = "FM";
  static MONTHLY_SALES_BILLED_SKU = "BSKU";
}